<template>
  <v-dialog
    :value="isVisible"
    :max-width="width"
    @click:outside="onCancel"
    @keydown="closeByEsc"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <button v-if="isHideButton" @click="onCancel">
            <v-icon>mdi-close</v-icon>
          </button>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-title />
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isHideButton && !hideCancel"
          color="green darken-1"
          text
          @click="onCancel"
          >{{ cancelText }}</v-btn
        >
        <v-btn
          v-if="!isHideButton && !hideOk"
          color="green darken-1"
          text
          :loading="loading"
          @click="onOk"
          >{{ okText }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    hideOk: {
      type: Boolean,
      default: false,
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    isHideButton: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 360,
    },
    okText: {
      type: String,
      default: '確定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    closeByEsc({ keyCode }) {
      if (keyCode === 27) {
        this.onCancel();
      }
    },
    onOk() {
      this.$emit('ok');
    },
    onCancel() {
      this.$emit(this.hideCancel ? 'ok' : 'cancel');
    },
  },
};
</script>
<style lang="scss">
.v-dialog {
  .headline {
    display: flex;
    justify-content: space-between;
    &.headline-center {
      justify-content: center;
    }
  }
  img {
    width: 100%;
  }
  .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
  }
}
</style>
